import { render, staticRenderFns } from "./TableContentCandidateList.vue?vue&type=template&id=4b633815&"
import script from "./TableContentCandidateList.vue?vue&type=script&lang=js&"
export * from "./TableContentCandidateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports